import Checkout from 'components/Checkout';
import Coupon from 'types/Coupon';
import CurrencyCode from 'types/CurrencyCode';
import MinimalLayout from 'components/MinimalLayout';
import Plan from 'types/Plan';
import * as styles from './CheckoutRoute.module.scss';

type Props = {
  annualPlan: Plan;
  coupon: Coupon;
  currencyCode: CurrencyCode;
  plans: Plan[];
  userId: number;
};

export default function CheckoutRoute({ annualPlan, coupon, currencyCode, plans, userId }: Props) {
  return (
    <MinimalLayout>
      <Checkout
        annualPlan={annualPlan}
        className={styles.content}
        coupon={coupon}
        currencyCode={currencyCode}
        initialPlan={plans[0]}
        userId={userId}
      />
    </MinimalLayout>
  );
}
